import axios from 'axios';
window.axios = axios;

window.axios.defaults.withCredentials = true;
window.axios.defaults.baseURL = '/';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
